import React from 'react';
import { Constants } from "@constants/Constants";

export const queryStringToObject = (query) => {
	const urlParams = new URLSearchParams(decodeURIComponent(query));
	const entries = urlParams?.entries();
	const result = {};
	for (const [key, value] of entries) {
		result[key] = value;
	}
	return result;
};

export const scrollToTop = () => window.scrollTo(0, 0);


export const getGCOMEnv = () => {
	const domain = window.location.hostname;
	if (Constants.HOST.DEV.indexOf(domain) !== -1) {
		return Constants.URLS.GARTNER_DEV;
	} else if (Constants.HOST.QA.indexOf(domain) !== -1) {
		return Constants.URLS.GARTNER_QA;
	}
	return Constants.URLS.GARTNER;
}

export const getToolsEnv = () => {
	const domain = window.location.hostname;
	if (Constants.HOST.DEV.indexOf(domain) !== -1) {
		return Constants.TOOLS_ENV.DEV;
	} else if (Constants.HOST.QA.indexOf(domain) !== -1) {
		return Constants.TOOLS_ENV.QA;
	}
	return Constants.TOOLS_ENV.PROD;
};

export const getCurrentPageForActis = () => {
	const path = window.location.pathname;
	if (path.includes(Constants.ROUTES.DETAIL)) {
		return Constants.ACTIS.CURRENT_PAGE.USECASE_DETAILS;
	} else if (path.includes(Constants.ROUTES.DASHBOARD)) {
		return Constants.ACTIS.CURRENT_PAGE.DASHBOARD;
	} else if (path.includes(Constants.ROUTES.SCORECARD)) {
		return Constants.ACTIS.CURRENT_PAGE.SCORECARD;
	}
	return Constants.ACTIS.CURRENT_PAGE.LANDING;
};

export const blobDownload = (data, name) => {
	const href = URL.createObjectURL(new Blob([data]));
	const link = document.createElement("a");
	link.href = href;
	link.setAttribute("download", name)
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
	URL.revokeObjectURL(href);
}

export const getCookie = (cname) => {
	const name = `${cname}=`;
	const cookieList = document.cookie.split(";");
	for (let i = 0; i < cookieList.length; i++) {
		const cookieItem = cookieList[i]?.trim();
		if (cookieItem.indexOf(name) === 0) {
			return cookieItem.split("=")[1];
		}
	}
	return "";
};

export const getAuthorizationToken = (name) => {
	const domain = window.location.host;
	if (domain.indexOf(Constants.ROUTES.APP_LOCAL_PATH) !== -1) {
		return getCookie(name);
	}
	return localStorage.getItem(name);
};

const deleteCookie = (name) => {
  document.cookie =
    name +
    "=; expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=.gartner.com; path=/; ";
};

export const deleteAuthorizationToken = (name) => {
  const domain = window.location.host;
  if (domain.indexOf(Constants.ROUTES.APP_LOCAL_PATH) !== -1) {
    return deleteCookie(name);
  }
  return localStorage.removeItem(name);
};

export const getUserRole = (roles) => {
	let userRole = Constants.GUEST_ROLE;
	if (roles?.includes(Constants.GARTNER_ASSOCIATE_ROLE)) {
		userRole = Constants.GARTNER_ASSOCIATE_ROLE;
	} else if (roles?.includes(Constants.CLIENT_ROLE)) {
		userRole = Constants.CLIENT_ROLE;
	}
	return userRole;
}

export const scrollToTarget = (target) => {
  if (target) {
    const targetPosition = target.getBoundingClientRect().top + window.scrollY;
    window.scrollTo({
      top: targetPosition - 80,
      behavior: "smooth",
    });
  }
};

export const isProd = () => getToolsEnv() === Constants.TOOLS_ENV.PROD;

export const isEmail = (email) => /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(
  email,
);

export const getStringWithBoldFormatting = (text = '') => {
  const regex = /<b>(.*?)<\/b>/g;
  const parts = text.split(regex);
  return (
    React.createElement('span', null, parts.map((part, index) => (index % 2 === 0 ? (
      part
    ) : (
      React.createElement('span', { style: { fontWeight: 600 }, key: part }, part)
    ))))
  );
};

export const isValidUrl = (urlString) => {
	try {
        new URL(urlString);
        return true;
	} catch (err) {
        return false;
	}
}

export const getDateInSpecificFormat = (date, format) => {
	const year = date.getFullYear();
	const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
	const fullMonth = date.toLocaleString('default', { month: 'long' });
	const day = String(date.getDate()).padStart(2, '0');

	if (format === 'fullMonth') {
		return `${day} ${fullMonth} ${year}`;
	} else if (format === 'fullMonthWithoutDate') {
		return `${fullMonth}, ${year}`;
	}
	return `${month}${day}${year}`;
}

export const getCurrentTabFromUrl = (pathname = '') => {
	const TABS_INDEX_PAIR = Constants.TABS_INDEX_PAIR;
  	TABS_INDEX_PAIR.sort((a, b) => b.PATH.length - a.PATH.length);
	const currTab = TABS_INDEX_PAIR.find(pair => pathname.includes(pair.PATH));
	return currTab.INDEX || 0;
}

export const getExpertInfo = (pathname) => {
	const {
		EXPERT_INQUIRY: {
			TITLE_FOR_USECASE, DESCRIPTION_FOR_USECASE, 
			TITLE_FOR_CASE_EXAMPLES, DESCRIPTION_FOR_CASE_EXAMPLES,
		},
		ROUTES: { DETAIL, SCORECARD, CASE_EXAMPLES },
	} = Constants;
	
	switch(true) {
	  case pathname.includes(CASE_EXAMPLES): 
		return { title: TITLE_FOR_CASE_EXAMPLES, description: DESCRIPTION_FOR_CASE_EXAMPLES };
	  case pathname.includes(DETAIL): 
		return { title: TITLE_FOR_USECASE, description: DESCRIPTION_FOR_USECASE };
	  default:
		return {};
	}
}
